const locale = {
	USER: 'FELHASZNÁLÓ',
	USER_LIST: 'Hozzáférés',
	DASHBOARD_ROLE: 'Jogkör'
};

export default locale;
